import { Mesh } from '../webgl/Mesh';
import { BufferAttributes } from '../webgl/BufferAttributes';
/**
 * 平面プレーンを作る
 * sharedPlaneを使うことで、ジオメトリを再利用できる
 */
export class Plane extends Mesh {
    static _sharedPlaneMesh;
    constructor(gl, width = 1, height = 1) {
        super(gl);
        const hw = width / 2;
        const hh = height / 2;
        this.setAttribute('POSITION', new BufferAttributes(gl, Plane.createPositions(width, height), 3));
        this.setAttribute('TEXCOORD', new BufferAttributes(gl, new Float32Array([0, 1, 1, 1, 1, 0, 0, 0]), 2));
        this.indices = new BufferAttributes(gl, new Uint16Array([0, 1, 2, 2, 3, 0]), 3);
        this.update();
    }
    static createPositions(width = 1, height = 1) {
        const hw = width / 2;
        const hh = height / 2;
        return new Float32Array([-hw, hh, 0, hw, hh, 0, hw, -hh, 0, -hw, -hh, 0]);
    }
    static sharedPlane(gl) {
        if (!Plane._sharedPlaneMesh) {
            Plane._sharedPlaneMesh = new Plane(gl, 1, 1);
        }
        return Plane._sharedPlaneMesh;
    }
    ;
    static dispose() {
        Plane._sharedPlaneMesh?.dispose();
        Plane._sharedPlaneMesh = undefined;
    }
}
//# sourceMappingURL=Plane.js.map